import axios from "axios";


//const BASE_URL = 'http://39.105.35.73:9012'; // 设置默认地址


const BASE_URL = 'https://www.huaxiastory.com:8085'; // 设置默认地址

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 5000, // 请求超时
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 在这里添加请求头或其他设置
    // config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // 处理响应错误
    return Promise.reject(error);
  }
);

export default instance;
